import React, { useState, useMemo } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Separator } from './ui/separator';
import { Dialog, DialogContent, DialogTrigger } from './ui/dialog';
import { X, CheckCircle, Clock, Phone, Mail, MessageCircle } from 'lucide-react';

const HOTMART_BASE = "https://pay.hotmart.com/B75108422N?checkoutMode=10";

function buildCheckoutUrl() {
  if (typeof window === "undefined") {
    return `${HOTMART_BASE}&src=pagina&sck=pagina`;
  }
  const url = new URL(window.location.href);
  const src = url.searchParams.get("src") || "pagina";
  const sck = url.searchParams.get("sck") || "pagina";
  return `${HOTMART_BASE}&src=${encodeURIComponent(src)}&sck=${encodeURIComponent(sck)}`;
}

export const ProductLanding = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const checkoutUrl = useMemo(buildCheckoutUrl, []);

  const productImages = [
    {
      id: 1,
      url: "https://customer-assets.emergentagent.com/job_54a3248c-ecce-4c95-b336-5dcc5ddce9a9/artifacts/qzbe3s4i_63.png",
      title: "Sumário do Combo",
      description: "Visão geral completa de todos os 15 materiais + 2 bônus inclusos"
    },
    {
      id: 2,
      url: "https://customer-assets.emergentagent.com/job_54a3248c-ecce-4c95-b336-5dcc5ddce9a9/artifacts/l0ee1sbf_60.png",
      title: "Cartões de Regulação para Pensamentos Destrutivos",
      description: "Ferramentas práticas para lidar com pensamentos negativos"
    },
    {
      id: 3,
      url: "https://customer-assets.emergentagent.com/job_54a3248c-ecce-4c95-b336-5dcc5ddce9a9/artifacts/e2csj3cd_61.png",
      title: "Bônus: Entendendo as Emoções",
      description: "Guia completo para adolescentes e adultos sobre regulação emocional"
    },
    {
      id: 4,
      url: "https://customer-assets.emergentagent.com/job_54a3248c-ecce-4c95-b336-5dcc5ddce9a9/artifacts/gdtco4x2_62.png",
      title: "Bônus: Entendendo o Modelo Cognitivo",
      description: "Compreenda como funciona nossa mente"
    },
    {
      id: 5,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/4r4eczny_46.png",
      title: "Caixa de Primeiros Socorros Emocionais",
      description: "Kit SOS para situações de crise emocional"
    },
    {
      id: 6,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/v55v3qqx_47.png",
      title: "Entendendo a Autolesão",
      description: "Material educativo sobre comportamentos autolesivos"
    },
    {
      id: 7,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/29emobh6_48.png",
      title: "Baralho dos Pensamentos - Sinais de Alerta",
      description: "Ferramenta para identificar sinais de crise"
    },
    {
      id: 8,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/08pxaixi_49.png",
      title: "Identificando Sinais de Alerta de uma Crise",
      description: "Guia para reconhecer momentos de vulnerabilidade"
    },
    {
      id: 9,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/r1mb42jl_50.png",
      title: "Instaurando a Esperança",
      description: "Técnicas para cultivar sentimentos de esperança e otimismo"
    },
    {
      id: 10,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/i6pkyx91_51.png",
      title: "Regulação Emocional",
      description: "Estratégias para gerenciar e regular as emoções"
    },
    {
      id: 11,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/qzxefw20_52.png",
      title: "Minha Rede de Apoio",
      description: "Identificando e construindo sua rede de suporte"
    },
    {
      id: 12,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/wy6icl1r_53.png",
      title: "Temporário ou Para Sempre",
      description: "Compreendendo a natureza transitória dos sentimentos"
    },
    {
      id: 13,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/0dzp4594_54.png",
      title: "Lidando com a Impulsividade",
      description: "Técnicas para controlar impulsos destrutivos"
    },
    {
      id: 14,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/k062mxpz_55.png",
      title: "Playlist do Bem-estar",
      description: "Música como ferramenta terapêutica para o bem-estar"
    },
    {
      id: 15,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/x10z5tol_56.png",
      title: "Habilidades de Resolução de Problemas",
      description: "Estratégias práticas para resolver conflitos e desafios"
    },
    {
      id: 16,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/4binrsic_57.png",
      title: "Cartões de Enfrentamento para Ideação Suicida",
      description: "Ferramentas específicas para lidar com pensamentos suicidas"
    },
    {
      id: 17,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/lkn03h27_58.png",
      title: "Cartões de Enfrentamento para Autolesão",
      description: "Estratégias direcionadas para prevenir comportamentos autolesivos"
    },
    {
      id: 18,
      url: "https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/i0cp8iew_59.png",
      title: "Meu Plano de Segurança",
      description: "Plano personalizado de proteção e autocuidado"
    }
  ];

  const productContents = [
    "Avaliação do Risco de Suicídio",
    "Entendendo a Autolesão",
    "Meu Plano de Segurança",
    "Regulação Emocional",
    "Instaurando a Esperança",
    "Minha Rede de Apoio",
    "Baralho: Identificando Sinais de Alerta de uma Crise",
    "Baralhos dos Pensamentos - Sinais de alerta",
    "Lidando com a Impulsividade + Cartões de Enfrentamento",
    "Habilidade de Resolução de Problemas",
    "Cartões de Enfrentamento para Ideação Suicida",
    "Cartões de Enfrentamento para Autolesão",
    "Playlist do Bem-estar",
    "Temporário ou para sempre",
    "Caixa SOS – primeiros socorros emocionais"
  ];

  const bonusContents = [
    "Bônus: Entendendo as Emoções",
    "Bônus: Entendendo o Modelo Cognitivo"
  ];

  const handlePurchase = () => {
    window.open(checkoutUrl, "_blank");
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/5519991584072', '_blank');
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FFF9F2' }}>
      {/* Header */}
      <header className="py-6 px-4 border-b border-gray-200">
        <div className="max-w-6xl mx-auto flex justify-center items-center">
          <div className="text-2xl font-bold" style={{ color: '#12162D' }}>
            CriAtivar Recursos Terapêuticos
          </div>
          {/*<button 
            onClick={handleWhatsApp}
            className="hover:scale-105 transition-transform"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_criativar-therapy/artifacts/63i645tn_LETRAS%20STORIES.PNG" 
              alt="WhatsApp Suporte" 
              className="w-12 h-12 object-contain"
            />
          </button>*/}
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-12 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <Badge 
            className="mb-6 text-white text-lg px-6 py-2"
            style={{ backgroundColor: '#FFC62E' }}
          >
            <Clock className="mr-2" size={16} />
            Oferta Setembro Amarelo - 20% OFF
          </Badge>
          
          <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" style={{ color: '#12162D' }}>
            Combo Tratamento da Ideação Suicida e Autolesão - em PDF
          </h1>
          
          <p className="text-xl mb-8 max-w-3xl mx-auto" style={{ color: '#132073' }}>
            Para adolescentes e adultos - Material completo em PDF com 15 ferramentas terapêuticas + 2 bônus exclusivos
          </p>

          {/* 
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <div className="text-center">
              <div className="text-lg line-through" style={{ color: '#132073' }}>
                De R$ 47,00
              </div>
              <div className="text-4xl font-bold" style={{ color: '#FA326E' }}>
                R$ 37,60
              </div>
              <div className="text-sm" style={{ color: '#132073' }}>
                com cupom AMARELO
              </div>
            </div>
          </div>
           

          <Button 
            onClick={handlePurchase}
            size="lg"
            className="text-white text-xl px-12 py-4 hover:scale-105 transition-transform"
            style={{ backgroundColor: '#FA326E' }}
          >
            Comprar Agora - R$ 37,60
          </Button>
          */}

        </div>
      </section>

      {/* Product Content */}
      <section className="py-12 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#12162D' }}>
            O que você receberá
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <Card className="p-6 shadow-lg border-2" style={{ borderColor: '#4C6EFC', backgroundColor: '#FFFODE' }}>
              <CardContent className="p-0">
                <h3 className="text-2xl font-bold mb-6" style={{ color: '#12162D' }}>
                  15 Materiais Principais
                </h3>
                <ul className="space-y-3">
                  {productContents.map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <CheckCircle size={20} style={{ color: '#40DEFF' }} className="mt-0.5 flex-shrink-0" />
                      <span style={{ color: '#132073' }}>{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>

            <Card className="p-6 shadow-lg border-2" style={{ borderColor: '#FFC62E', backgroundColor: '#FFFODE' }}>
              <CardContent className="p-0">
                <h3 className="text-2xl font-bold mb-6" style={{ color: '#12162D' }}>
                  2 Bônus Exclusivos
                </h3>
                <ul className="space-y-3 mb-6">
                  {bonusContents.map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <CheckCircle size={20} style={{ color: '#FFC62E' }} className="mt-0.5 flex-shrink-0" />
                      <span style={{ color: '#132073' }}>{item}</span>
                    </li>
                  ))}
                </ul>
                <div className="p-4 rounded-lg" style={{ backgroundColor: '#FFF9F2' }}>
                  <p className="text-sm font-semibold" style={{ color: '#FA326E' }}>
                    ✨ Materiais bônus inclusos sem custo adicional!
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Image Gallery */}
      <section className="py-16 px-4" style={{ backgroundColor: '#FFFODE' }}>
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#12162D' }}>
            Veja os materiais por dentro
          </h2>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {productImages.map((image) => (
              <Dialog key={image.id}>
                <DialogTrigger asChild>
                  <Card className="cursor-pointer hover:scale-105 transition-transform shadow-lg">
                    <CardContent className="p-4">
                      <img 
                        src={image.url} 
                        alt={image.title}
                        className="w-full h-48 object-cover rounded-lg mb-4"
                      />
                      <h3 className="font-semibold mb-2" style={{ color: '#12162D' }}>
                        {image.title}
                      </h3>
                      <p className="text-sm" style={{ color: '#132073' }}>
                        {image.description}
                      </p>
                    </CardContent>
                  </Card>
                </DialogTrigger>
                <DialogContent className="max-w-4xl">
                  <img 
                    src={image.url} 
                    alt={image.title}
                    className="w-full h-auto rounded-lg"
                  />
                </DialogContent>
              </Dialog>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-12 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#12162D' }}>
            Garanta seu combo com desconto especial
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <div className="text-center">
              <div className="text-lg line-through" style={{ color: '#132073' }}>
                De R$ 47,00
              </div>
              <div className="text-4xl font-bold" style={{ color: '#FA326E' }}>
                R$ 37,60
              </div>
              <div className="text-1xl font-bold mb-2" style={{ color: '#12162D' }}>
                com cupom:
              </div>
              <div className="text-3xl font-bold" style={{ color: '#FFC62E' }}>
                AMARELO
              </div>
            </div>
          </div>

          
           

          <Button 
            onClick={handlePurchase}
            size="lg"
            className="text-white text-xl px-12 py-4 hover:scale-105 transition-transform"
            style={{ backgroundColor: '#FA326E' }}
          >
            Comprar Agora
          </Button>
          
          {/*
          <div className="mb-8 p-6 rounded-lg shadow-lg" style={{ backgroundColor: '#FFFODE' }}>
            <div className="text-sm font-semibold mb-2" style={{ color: '#FFC62E' }}>
              🎯 OFERTA SETEMBRO AMARELO
            </div>
            <div className="text-2xl font-bold mb-2" style={{ color: '#FA326E' }}>
              Use o cupom: AMARELO
            </div>
            <div className="text-lg" style={{ color: '#132073' }}>
              E economize 20% - De R$ 47,00 por apenas R$ 37,60
            </div>
          </div>

          <Button 
            onClick={handlePurchase}
            size="lg"
            className="text-white text-xl px-12 py-4 hover:scale-105 transition-transform mb-8"
            style={{ backgroundColor: '#FA326E' }}
          >
            Comprar Agora - R$ 37,60
          </Button>
          */}

          <p className="text-sm" style={{ color: '#132073' }}>
            Material digital em PDF
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-4 border-t border-gray-200">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold mb-6" style={{ color: '#12162D' }}>
              Precisa de ajuda?
            </h3>
            
            <div className="grid sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
              <div className="flex items-center justify-center gap-3 p-4 rounded-lg" style={{ backgroundColor: '#FFFODE' }}>
                <Phone size={20} style={{ color: '#40DEFF' }} />
                <div className="text-left">
                  <div className="font-semibold" style={{ color: '#12162D' }}>WhatsApp</div>
                  <div style={{ color: '#132073' }}>19 99158 4072</div>
                </div>
              </div>
              
              <div className="flex items-center justify-center gap-3 p-4 rounded-lg" style={{ backgroundColor: '#FFFODE' }}>
                <Mail size={20} style={{ color: '#40DEFF' }} />
                <div className="text-left">
                  <div className="font-semibold" style={{ color: '#12162D' }}>Email</div>
                  <div style={{ color: '#132073' }}>contato@recursoscriativar.com.br</div>
                </div>
              </div>
            </div>
          </div>

          <Separator className="my-8" />
          
          <div className="text-center">
            <p className="text-lg font-bold mb-2" style={{ color: '#12162D' }}>
              CriAtivar Recursos Terapêuticos
            </p>
            <p className="text-sm" style={{ color: '#132073' }}>
              © 2025 - Todos os direitos reservados
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};